import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import {
  Button,
  FormatText,
  FormDatePicker,
  FormInput,
  FormItem,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
  Upload,
  Widget,
} from '@digital/ui';

import { hasPermission } from '@app/helpers/permissions';
import CurrencyInput from '@app/components/CurrencyInput';

import { anexarNovoDocumentoCobranca, urlDownloadArquivo } from '@app/api/autorizacaoPagamento/autorizacao';

import './modal.css';
import { UploadFile } from '@app/components';

export interface PropsModalAnexarNovoDocumento {
  arquivoAutorizacaoId: string;
  setUpdate: any;
}

const ModalAnexarNovoDocumento = (props: PropsModalAnexarNovoDocumento) => {
  const { arquivoAutorizacaoId, setUpdate } = props;

  const [fileDocumento, setFileDocumento] = useState([]);
  const [fileEvidencia, setFileEvidencia] = useState([]);
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = values => {
    anexarNovoDocumentoCobranca(values, arquivoAutorizacaoId).then(data => {
      setUpdate(null);
      setUpdate(true);
    });
  };

  return (
    <>
      <Tooltip title="Anexar novo documento de cobrança e evidência de cancelamento">
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
          icon="files-add_file"
          name="btnAnexarNovoDocumento"
        />
      </Tooltip>
      <Modal
        title="Anexos"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormInput name="documentoCobrancaNumero" label="Número do Documento" span={4} />
            <FormDatePicker name="dataEmissao" label="Data de Emissão" format="DD/MM/YYYY" span={4} />
            <CurrencyInput name="valor" label="Valor" span={4} />
            <FormItem name="fileDocumento" span={6}>
              <UploadFile
                nameFormData="fileDocumento"
                label="Documento Cobrança"
                key="fileDocumento"
                hasFile={true}
                url={'fileDocumento' + '&fileName=' + fileDocumento}
              />
            </FormItem>
            <FormItem name="fileEvidencia" span={6}>
              <UploadFile
                nameFormData="fileEvidencia"
                label="Evidencia de Cancelamento"
                key="fileEvidencia"
                hasFile={true}
                url={'fileEvidencia' + '&fileName=' + fileEvidencia}
              />
            </FormItem>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalAnexarNovoDocumento;
